import { requireAuthOrProspectEmail } from '../guards';

export const path = '/:product?/membership/:offerId?/join';
export const component = 'StartMembershipOrder';
export const thunk = () => requireAuthOrProspectEmail;
